import styled from 'styled-components'

import { helpers } from 'styles'

export const Title = styled.h1`
	color: ${helpers.color.textHeader};
	font-size: ${helpers.font.size.header};
	font-family: ${helpers.font.family.header};
	font-weight: 400;
	margin: 0 0 16px;
`
